(function () {
  'use strict';

  var STORAGE_KEY = 'raelon_passive_attribution_v1';
  var FIELD_ATTRIBUTE = 'data-raelon-passive-field';
  var MAX_CAMPAIGN_LENGTH = 200;
  var MAX_CLICK_ID_LENGTH = 255;
  var MAX_PATH_LENGTH = 500;
  var MAX_REFERRER_LENGTH = 500;

  function limit(value, maxLength) {
    return String(value || '').slice(0, maxLength);
  }

  function pageUrl() {
    try {
      return new URL(document.URL);
    } catch (error) {
      return null;
    }
  }

  function currentPath() {
    var url = pageUrl();
    return url ? limit(url.pathname || '/', MAX_PATH_LENGTH) : '';
  }

  function readParameter(name, maxLength) {
    var url = pageUrl();
    if (!url) return '';

    try {
      return limit(url.searchParams.get(name), maxLength);
    } catch (error) {
      return '';
    }
  }

  function isRaelonHost(hostname) {
    var host = String(hostname || '').toLowerCase();
    return host === 'raelon.ca' || host === 'www.raelon.ca' || host.slice(-10) === '.raelon.ca';
  }

  function externalReferrer() {
    if (!document.referrer) return '';

    try {
      var sourceUrl = pageUrl();
      var referrerUrl = new URL(document.referrer);
      if (referrerUrl.protocol !== 'http:' && referrerUrl.protocol !== 'https:') return '';
      if (sourceUrl && referrerUrl.origin === sourceUrl.origin) return '';
      if (isRaelonHost(referrerUrl.hostname)) return '';
      return limit(referrerUrl.origin, MAX_REFERRER_LENGTH);
    } catch (error) {
      return '';
    }
  }

  function analyticsStorageAllowed() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function') return true;

    try {
      return privacy.analyticsProcessingAllowed() !== false;
    } catch (error) {
      return false;
    }
  }

  function readFirstTouch() {
    try {
      var raw = window.sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      return parsed && typeof parsed === 'object' ? parsed : null;
    } catch (error) {
      return null;
    }
  }

  function writeFirstTouch(firstTouch) {
    try {
      window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(firstTouch));
    } catch (error) {
      // Attribution must never affect the Quote form when storage is unavailable.
    }
  }

  function captureFirstTouch() {
    var stored = readFirstTouch();
    if (stored) return stored;

    var firstTouch = {
      source: readParameter('utm_source', MAX_CAMPAIGN_LENGTH),
      medium: readParameter('utm_medium', MAX_CAMPAIGN_LENGTH),
      campaign: readParameter('utm_campaign', MAX_CAMPAIGN_LENGTH),
      content: readParameter('utm_content', MAX_CAMPAIGN_LENGTH),
      term: readParameter('utm_term', MAX_CAMPAIGN_LENGTH),
      gclid: readParameter('gclid', MAX_CLICK_ID_LENGTH),
      fbclid: readParameter('fbclid', MAX_CLICK_ID_LENGTH),
      msclkid: readParameter('msclkid', MAX_CLICK_ID_LENGTH),
      landingPage: currentPath(),
      externalReferrer: externalReferrer(),
      timestamp: new Date().toISOString()
    };

    writeFirstTouch(firstTouch);
    return firstTouch;
  }

  function firstTouchValue(firstTouch, key) {
    if (!firstTouch) return '';

    var values = {
      first_source: firstTouch.source,
      first_medium: firstTouch.medium,
      first_campaign: firstTouch.campaign,
      first_content: firstTouch.content,
      first_term: firstTouch.term,
      first_landing_page: firstTouch.landingPage,
      first_external_referrer: firstTouch.externalReferrer,
      first_gclid: firstTouch.gclid,
      first_fbclid: firstTouch.fbclid,
      first_msclkid: firstTouch.msclkid,
      first_visit_timestamp: firstTouch.timestamp
    };

    return values[key] || '';
  }

  function populateFields() {
    var firstTouch = analyticsStorageAllowed() ? captureFirstTouch() : null;
    var quotePage = currentPath();
    var populatedAt = new Date().toISOString();
    var fields = document.querySelectorAll('input[' + FIELD_ATTRIBUTE + ']');

    Array.prototype.forEach.call(fields, function (field) {
      var key = field.getAttribute(FIELD_ATTRIBUTE);

      if (key === 'quote_page') {
        field.value = quotePage;
      } else if (key === 'quote_product_handle') {
        field.value = limit(field.getAttribute('data-raelon-product-handle'), 255);
      } else if (key === 'quote_submitted_at') {
        field.value = populatedAt;
      } else {
        field.value = limit(firstTouchValue(firstTouch, key), 500);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', populateFields);
  window.addEventListener('pageshow', populateFields);
}());
